export default "__VITE_ASSET__PzMoqUtc__"